<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome Back !</h5>
                  <p>Sign in to continue to OLAMS.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img alt="" class="img-fluid" src="assets/images/profile-img.png">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img alt="" class="rounded-circle" height="34" src="assets/images/logo.png">
                  </span>
                </div>
              </a>
            </div>
            <div class="p-2">
              <form (ngSubmit)="onLoginSubmit($event, loginForm.value)" [formGroup]="loginForm" class="form-horizontal">
                <ngb-alert *ngIf="error?.length>0" [dismissible]="true" type="danger">
                  <i class="mdi mdi-block-helper me-2"></i>
                  {{ error }}
                </ngb-alert>

                <div class="mb-3">
                  <label for="Username">Username</label>
                  <input [ngClass]="{ 'is-invalid': (f?.username?.dirty || f?.username?.touched) && f.username.errors }"
                         class="form-control" formControlName="username" id="Username" placeholder="S0000.0000.2000"
                         (keyup)="validateUsername()"
                         type="text"/>
                  <div *ngIf="(f.username.dirty || f.username.touched) && f.username.errors" class="invalid-feedback">
                    <div *ngIf="f.username?.errors?.required">username is required</div>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="password">Password</label>
                  <div class="input-group auth-pass-inputgroup">
                    <input [ngClass]="{ 'is-invalid': (f?.password?.dirty || f?.password?.touched) && f.password.errors }"
                           aria-describedby="password-addon" aria-label="Password" class="form-control" formControlName="password"
                           id="password" placeholder="Enter password"
                           type="password">

                    <button class="btn btn-light ms-0" id="password-addon" type="button"><i
                      class="mdi mdi-eye-outline"></i></button>
                    <div *ngIf="(f.password.dirty || f.password.touched) && f.password.errors" class="invalid-feedback">
                      <span *ngIf="f.password?.errors?.required">Password is required</span>
                    </div>
                  </div>
                </div>

                <div class="form-check">
                  <input class="form-check-input" id="remember-check" type="checkbox">
                  <label class="form-check-label" for="remember-check">
                    Remember me
                  </label>
                </div>
                <div class="mt-3 d-grid">
                  <button [disabled]="isButtonDisabled" class="btn btn-primary" [ladda]="loading" type="submit">Log In</button>
                </div>
                <p style="color: red; padding: 10px;" *ngIf="isButtonDisabled">Login is disabled. Please try again in <b style="font-size: 20px;">{{ remainingTime }}</b> seconds.</p>
                <div class="mt-4 text-center">
                  <a class="text-muted" routerLink="/account/reset-password"><i class="mdi mdi-lock mr-1"></i> Forgot
                    your
                    password?</a>
                </div>
              </form>
            </div>

          </div>
        </div>
        <div class="mt-5 text-center">
          <p>Don't have an account ? <a class="fw-medium text-primary" routerLink="/account/signup"> Signup
            now
          </a></p>
          <p>© {{year}} HESLB. All Rights Reserved</p>
        </div>

      </div>
    </div>
  </div>

  <!-- end container -->
</div>
<!--yelawolf-->
<!-- end page -->
